import {
  formatExpiryDate,
  getExpiryDays,
  isCredentialExpired,
} from "@/features/credentials/pages/list/lib/format-expiry";
import { cn, Hint } from "@cmde/shadcn";
import { useTranslation } from "react-i18next";

export function CredentialExpiryDate({ expiryDate }: { expiryDate?: string | null }) {
  const { t, i18n } = useTranslation();

  if (!expiryDate) {
    return "—";
  }

  const days = getExpiryDays(expiryDate);
  if (days == null) {
    return expiryDate;
  }

  const expired = isCredentialExpired(expiryDate);
  const relativeLabel =
    days === 0
      ? t("credentials.list.expiry.today")
      : days > 0
        ? t("credentials.list.expiry.inDays", { count: days })
        : t("credentials.list.expiry.daysAgo", { count: Math.abs(days) });

  return (
    <Hint content={formatExpiryDate(expiryDate, i18n.language)}>
      <span className={cn("cursor-default", expired && "text-destructive")}>{relativeLabel}</span>
    </Hint>
  );
}
